import './Modal.scss';

import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useId, useRef } from 'react';
import { faCheckCircle, faCircleExclamation, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import AppButton from '../buttons/AppButton';
import AppLinkButton from '../buttons/AppLinkButton';
import AppLoading from '../AppLoading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';

const TYPE_ICON = {
  danger: faTriangleExclamation,
  warning: faCircleExclamation,
  info: faCircleInfo,
  success: faCheckCircle,
};

const TYPE_CONFIRM_VARIANT = {
  danger: 'danger',
  warning: 'warning',
  info: 'primary',
  success: 'primary',
};

function ConfirmModal({
  show,
  closeModal,
  title = 'Confirmar ação',
  confirm,
  isLoading = false,
  children,
  disabledBtn = false,
  textBtnConfirm = "Excluir",
  textBtnCancel = "Cancelar",
  type = 'danger',                  // 'danger' | 'warning' | 'info' | 'success'
  confirmVariant,                   // sobrescreve o variant padrão por tipo
  cancelVariant = 'link',           // estilo do botão cancelar
  confirmIcon,                      // sobrescreve o ícone padrão por tipo
  autofocusConfirm = true,          // foca no botão confirmar ao abrir
  ariaLabelledBy,                   // ids opcionais para acessibilidade
  ariaDescribedBy,
}) {
  const bodyId = useId();
  const confirmRef = useRef(null);

  useEffect(() => {
    if (show && autofocusConfirm && confirmRef.current) {
      // pequeno timeout para garantir foco após animação
      const t = setTimeout(() => confirmRef.current?.focus(), 150);
      return () => clearTimeout(t);
    }
  }, [show, autofocusConfirm]);

  const icon = confirmIcon || TYPE_ICON[type] || TYPE_ICON.info;
  const computedConfirmVariant = confirmVariant || TYPE_CONFIRM_VARIANT[type] || 'primary';
  const describedBy = ariaDescribedBy || bodyId;

  return (
    <Modal
      className="hallapp-modal custom-backdrop"
      centered
      show={show}
      onHide={closeModal}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={describedBy}
    >
      <Modal.Header closeButton style={{ border: 'none', padding: 20 }}>
        <Modal.Title id={ariaLabelledBy}>
          <span className={`confirm-modal__icon confirm-modal__icon--${type}`}>
            <FontAwesomeIcon icon={icon} />
          </span>
          <span className="confirm-modal__title-text">{title}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id={describedBy}>
        {children}
      </Modal.Body>

      <Modal.Footer style={{ border: 'none', padding: 20 }}>
        <Row className="justify-content-end g-2" style={{ width: '100%' }}>
          <Col xs="auto">
            <AppLinkButton
              name={textBtnCancel?.toUpperCase()}
              onClick={closeModal}
              variant={cancelVariant}
              aria-label="Cancelar e fechar modal"
            />
          </Col>
          <Col xs="auto">
            <AppButton
              ref={confirmRef}
              name={isLoading ? 'Aguarde...' : textBtnConfirm}
              onClick={confirm}
              disabled={disabledBtn || isLoading}
              loading={isLoading}
              variant={computedConfirmVariant}
              aria-label={`${textBtnConfirm} e confirmar ação`}
            />
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;